import { IPermission } from "./types";
import { Types } from "./actions";

const initialState: IPermission = {
    userProfile: undefined
};

export const AuthReducer = (state: IPermission = initialState, action: any): IPermission => {
    switch (action.type) {
        case Types.GET_CURRENT_USER_INFO: {
            return {
                ...state,
                userProfile: action.data
            };
        }
        default:
            return state; // ✅ Always include default case
    }
}